import Service 							from "./../../Libs/Service";
import Request 							from "./../../Libs/Service.Request";
import Socket							from "./../../Libs/Service.Socket";

import SetupSettings 					from "./../settings/settings.json";

import { Metadata } 					from "./Metadata";
import { User } 						from "./User";
import { Publisher } 					from "./Publisher";
import { Creative } 						from "./Creative";
import { Auth } 						from "./Auth";
import { Cluster } 						from "./Cluster";

// Соединения клиента с нодами кластера.
//
// Первичное соединение - нода, на которой живёт аккаунт пользователя: через неё идут все запросы
// клиента и приходят его данные. Админам дополнительно нужны списки остальных нод, поэтому клиент
// открывает к ним вторичные соединения: каждая нода отдаёт свой список паблишеров, а клиент
// складывает их вместе с номером ноды (Documents/Cluster.txt).
let Server = new Service({

	Name: "Server",

	Libraries: [Request, Socket],

	Events: {

		"Socket Connection Established": function(serverId) {

			// Токен авторизации передаём в данных Init, а не в адресе сокета, чтобы он не попадал в логи
			let initData = {
				token: Auth.getToken()
			};

			// Вторичное соединение: админ подключается к остальным нодам кластера только за списками,
			// метаданные и данные креативов по нему не переотправляются
			// (Server/Services/Environment/Environment.mjs, initSecondaryConnection)
			if (serverId !== this.getPrimaryServerId()) initData.Secondary = true;

			if (location.pathname.indexOf('/invitation/') === 0) initData.Invitation = location.pathname.substr(12);

			// Уведомление о входе (например о том, что пользователь уже привязан к другому паблишеру)
			let loginNotice = Auth.consumeLoginNotice();
			if (loginNotice) initData.LoginNotice = loginNotice;

			this.sendToSocket({
				Init: initData
			}, serverId);

			// Первичное соединение: клиент возвращается к тому же паблишеру и креативу, что были открыты
			if (serverId === this.getPrimaryServerId()) {

				if (Publisher.SelectedPublisher) Layout.setPublisher(Publisher.SelectedPublisher.id);
				if (Creative.SelectedCreative) Layout.setCreative(Creative.SelectedCreative.id);

			}

		}

	},

	Actions: {

		'*': function(data, size, serverId) {

			console.info(`%c<<< SERVER ${serverId || 0} DATA << ${Math.round(size / 1000)}kb <<`, 'color: #bada55', data);

			_.each(data, (value, key) => {

				// Номер ноды-источника передаём дальше: по нему сервисы раскладывают данные по нодам
				Broadcast.call(`Server Data:${key}`, [value, data, serverId]);

			});

			setTimeout(() => {

				//Админам нужны списки со всех нод кластера: подключаемся к остальным нодам сразу,
				//как только известны метаданные и текущий пользователь. Ждать полной загрузки нельзя:
				//выбранный паблишер может жить на другой ноде, и её данные приходят только по вторичному
				//соединению (сам выбор паблишера ждёт их - см. Publisher.autoSelectPublisher)
				if (Metadata.loaded && User.loaded && User.currentUser?.isAdmin) this.connectClusterNodes();

				//Если получен текущий пользователь
				if (Metadata.loaded && User.loaded && Publisher.loaded && Creative.isSelectedCreativeLoaded() && !this.loaded) {

					this.loaded = true;

					Broadcast.call("Server Data Loaded");

				}

			}, 10);

		},

		'Reload': function() {

			window.location.reload();
		}

	},

	init() {

		this.loaded = false;

		this.timeouts = {};

		// global access needed sometimes for the debug purposes (do not use global SetupSettings object in the code)
		window.SetupSettings = SetupSettings;

	},

	connect() {

		//Номер ноды аккаунта известен после входа (Auth): под ним и регистрируем первичное соединение
		this.setPrimaryServerId(Auth.getServerId());

		//Пока не выбран паблишер другой ноды, рабочая нода - нода аккаунта: с неё приходят
		//пользователь и списки паблишеров, поэтому активными должны быть её карты данных
		if (!Publisher.SelectedPublisher) Cluster.useServer(this.getPrimaryServerId());

		//Адрес ноды аккаунта берём у Auth: клиент мог быть загружен с другой ноды, а общие настройки
		//клиента позже переключаются на ноду выбранного паблишера (Auth.applyWorkingServerAddress)
		let protocol = location.protocol === 'https:' ? 'wss' : 'ws';

		this.connectSocket(`${protocol}://${Auth.getServerAddress()}/ws`, this.getPrimaryServerId());

	},

	//Админы подключаются ко всем нодам кластера: каждая нода отдаёт свой список паблишеров,
	//а клиент складывает их вместе с номером ноды (Documents/Cluster.txt)
	connectClusterNodes() {

		if (!User.currentUser?.isAdmin) return;

		_.each(Metadata.Servers, server => {

			//Нода аккаунта уже подключена первичным соединением
			if (server.id === this.getPrimaryServerId()) return;

			this.connectSocket(this.getServerSocketUrl(server), server.id);

		});

	},

	//Адрес сокет-соединения ноды кластера
	getServerSocketUrl(server) {

		let protocol = location.protocol === 'https:' ? 'wss' : 'ws';

		//В режиме разработки у ноды свой порт, в продакшене внешний порт закрывает nginx
		return `${protocol}://${Auth.getNodeAddress(server.id)}/ws`;

	},

	sendWithTimeout(data, timeoutKey = null, timeout = 1000, next = null) {

		if (!timeoutKey) timeoutKey = _.keys(data)[0];

		clearTimeout(this.timeouts[timeoutKey]);
		this.timeouts[timeoutKey] = setTimeout(() => {

			Server.sendToSocket(data);

			if (next) next();

		}, timeout);

	}

});

window.Server = Server;

export { Server }
